import React from 'react'
import { Link } from "react-router-dom";


const HomeBlog = () => {
    return (
        <>

            <section className="blog pt_120 xs_pt_100" style={{ marginTop: "-40px" }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-8 col-xl-8 wow fadeInLeft" style={{ visibility: 'visible', animationName: 'fadeInLeft' }}>
                            <div className="section_heading left_heading mb_20">
                                <h5>blog &amp; news</h5>
                                <h2>Latest New and Blog</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_blog">
                                <Link to="/blog-details" className="single_blog_img">
                                    <img src="assets/img/Business Solutions.webp" alt="Blog" className="img-fluid" />
                                </Link>
                                <div className="single_blog_text">
                                    <Link className="category" to="/blog-details">Business Solutions</Link>
                                    {/* <ul className="d-flex flex-wrap">
                                        <li>
                                            <span><img src="assets/images/calendar_icon_blue.svg" alt="Calendar" className="img-fluid" /></span>
                                            Feb 10 2025
                                        </li>
                                        <li>
                                            <span><img src="assets/images/comment_icon_blue.svg" alt="Comment" className="img-fluid" /></span>
                                            Comments (09)
                                        </li>
                                    </ul> */}
                                    <Link className="title" to="/blog-details">Why Businesses Need Integrated Business Solutions in 2026</Link>
                                    <p>Running a business involves managing multiple services—from company registration and GST compliance to website development, manpower, and facility management. Choosing a single service provider helps improve efficiency, reduce costs, and simplify business operations.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_blog">
                                <Link to="/blog-details" className="single_blog_img">
                                    <img src="assets/img/Facility Management_1.webp" alt="Blog" className="img-fluid" />
                                </Link>
                                <div className="single_blog_text">
                                    <Link className="category" to="/blog-details">Facility Management</Link>
                                    {/* <ul className="d-flex flex-wrap">
                                        <li>
                                            <span><img src="assets/images/calendar_icon_blue.svg" alt="Calendar" className="img-fluid" /></span>
                                            Mar 21 2025
                                        </li>
                                        <li>
                                            <span><img src="assets/images/comment_icon_blue.svg" alt="Comment" className="img-fluid" /></span>
                                            Comments (43)
                                        </li>
                                    </ul> */}
                                    <Link className="title" to="/blog-details">Top Benefits of Professional Facility Management Services</Link>
                                    <p>A well-managed facility improves workplace productivity, employee satisfaction, and operational efficiency. Professional facility management ensures your business remains clean, secure, and fully operational.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                            <div className="single_blog">
                                <Link to="/blog-details" className="single_blog_img">
                                    <img src="assets/img/Professional Website.webp" alt="Blog" className="img-fluid" />
                                </Link>
                                <div className="single_blog_text">
                                    <Link className="category" to="/blog-details">Professional Website</Link>
                                    {/* <ul className="d-flex flex-wrap">
                                        <li>
                                            <span><img src="assets/images/calendar_icon_blue.svg" alt="Calendar" className="img-fluid" /></span>
                                            Apr 17 2025
                                        </li>
                                        <li>
                                            <span><img src="assets/images/comment_icon_blue.svg" alt="Comment" className="img-fluid" /></span>
                                            Comments (38)
                                        </li>
                                    </ul> */}
                                    <Link className="title" to="/blog-details">Why Every Business Needs a Professional Website</Link>
                                    <p>Your website is your digital storefront. A professionally designed website builds trust, improves visibility on search engines, and helps convert visitors into customers.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                </div>
            </section>

        </>
    )
}

export default HomeBlog